export const CART = "icon-bag";
export const WISHLIST = "icon-heart";
export const ERROR = "icon-power";
export const APP = "icon-ribbon";
export const INFO = "icon-info";
export const COPY = "pe-7s-copy-file";
export const EMAIL = 'socicon-mail';
